import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import NavButton from "./navbutton"
import { twMerge } from "tailwind-merge"
const PopNav = () => {
  const data = useStaticQuery(graphql`
    {
      logo: site {
        siteMetadata {
          brand {
            uyf
            singlestep
            rc
            plasmid
            og
            nano
            extreme
            lowevap
            standard
            airotop
          }
        }
      }
    }
  `)
  const { logo } = data
  return (
    <>
      <PopMenuItem>
        <PopText>
          <PopTitle>{logo.siteMetadata.brand.uyf} System</PopTitle>
          <PopDescription>
            <em>E. coli</em> & microbial cell culture solutions providing
            superior results when all three components are used simultaneously.
          </PopDescription>
          <PopLinks>
            <PopLink color="indigo" to="/uyf">
              Flasks
            </PopLink>
            <PopLink color="indigo" to="/uyf/plasmid">
              {logo.siteMetadata.brand.plasmid} Media
            </PopLink>
            <PopLink color="indigo" to="/uyf/airotop">
              {logo.siteMetadata.brand.airotop} Seals
            </PopLink>
            <PopLink color="indigo" to="/uyf/accessoriesuyf">
              Accessories
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
      <PopMenuItem>
        <PopText>
          <PopTitle>{logo.siteMetadata.brand.og} System</PopTitle>
          <PopDescription>
            Mammalian & insect cell culture offerings supporting 40-50% fill
            volumes.
          </PopDescription>
          <PopLinks>
            <PopLink color="purple" to="/og">
              Flasks
            </PopLink>
            <PopLink color="purple" to="/og/special">
              Special Flasks
            </PopLink>
            <PopLink color="purple" to="/og/tc">
              Transfer Caps
            </PopLink>
            <PopLink color="purple" to="/rc">
              {logo.siteMetadata.brand.rc} Caps
            </PopLink>
            <PopLink color="purple" to="/og/accessoriesog">
              Accessories
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
      <PopMenuItem>
        <PopText>
          <PopTitle>Filter Vials</PopTitle>
          <PopDescription>
            15 seconds, to filtered samples in an autosampler-ready vial.
          </PopDescription>
          <PopLinks>
            <PopLink color="teal" to="/fv/extreme">
              {logo.siteMetadata.brand.extreme}
            </PopLink>
            <PopLink color="teal" to="/fv/standard">
              {logo.siteMetadata.brand.standard}
            </PopLink>
            <PopLink color="teal" to="/fv/nano">
              {logo.siteMetadata.brand.nano}
            </PopLink>
            <PopLink color="teal" to="/fv/lowevap">
              {logo.siteMetadata.brand.lowevap}
            </PopLink>
            <PopLink color="teal" to="/fv/accessoriesfv">
              Accessories
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
      <PopMenuItem>
        <PopText>
          <PopTitle>Collection & Filter Plates</PopTitle>
          <PopDescription>
            Ideal for biological as well as analytical sample preparation.
          </PopDescription>
          <PopLinks>
            <PopLink color="pink" to="/wp">
              Well Plates
            </PopLink>
            <PopLink color="pink" to="/fp">
              Filter Plates
            </PopLink>
            <PopLink color="pink" to="/seals">
              Capmats, Seals & Lids
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
      <PopMenuItem>
        <PopText>
          <PopTitle>Glassware</PopTitle>
          <PopDescription>Caps, Vials, & Blocks</PopDescription>
          <PopLinks>
            <PopLink color="gray" to="/glassware">
              Glassware
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
      <PopMenuItem>
        <PopText>
          <PopTitle>Empty Columns</PopTitle>
          <PopDescription>
            Different sized columns with wide mouth opening for sorbents &
            resins.
          </PopDescription>
          <PopLinks>
            <PopLink color="blue" to="/columns">
              {logo.siteMetadata.brand.singlestep}
            </PopLink>
          </PopLinks>
        </PopText>
      </PopMenuItem>
    </>
  )
}
const PopMenuItem = props => {
  return (
    <div
      className={twMerge([
        "flex items-start border-b border-slate-50 px-0 py-4 transition last:border-b-0 lg:-m-3 lg:border-0 lg:px-3 lg:py-1",
        props.className,
      ])}
    >
      {props.children}
    </div>
  )
}
const PopText = props => {
  return (
    <div className={twMerge(["space-y-2", props.className])}>
      {props.children}
    </div>
  )
}
const PopTitle = props => {
  return (
    <p
      className={twMerge([
        "text-base font-medium leading-4 text-slate-900",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}
const PopDescription = props => {
  return (
    <p
      className={twMerge([
        "text-sm leading-tight text-slate-400",
        props.className,
      ])}
    >
      {props.children}
    </p>
  )
}
const PopLinks = props => {
  return (
    <div
      className={twMerge([
        "flex flex-wrap items-center justify-start text-sm lg:text-xs",
        props.className,
      ])}
    >
      {props.children}
    </div>
  )
}
const PopLink = props => {
  return (
    <NavButton
      square
      color={props.color}
      to={props.to}
      className="mb-4 mr-4 lg:mb-2 lg:mr-2"
    >
      {props.children}
    </NavButton>
  )
}

export default PopNav
